import { trackPromise } from 'react-promise-tracker';
import api from '../api/api';

const GtmService = {
  sendGtm: (data: object) =>
    trackPromise(api.post('/rest/gtm/send/event', JSON.stringify(data))),
  getIp: () => trackPromise(api.post('/rest/gtm/get/ip')),
};
export default GtmService;
